/**
 * Component to handle a click on the button for more/less information.
 * @param isExpanded
 * @param setIsExpanded
 */
export const OnToggleButtonClick = (isExpanded: boolean, setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>) => {
  setIsExpanded(!isExpanded);
};
